import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { NotificationIdentifierModel } from '../../models/low-level/notification-identifier.model';
import {
    JsonNotificationUpdateModel,
    NotificationUpdateModel,
    NotificationUpdateModelFromJson,
} from '../../models/low-level/notification-update.model';
import { LocalStorageCommonService } from '../local-storage/local-storage-common.service';

const KEY_NEWUPDATES = 'newUpdates';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageNotificationUpdateService {
    public constructor(private localStorageCommonService: LocalStorageCommonService) {}

    public async getLatestNewUpdateAsync(
        notificationIdentifier: NotificationIdentifierModel,
    ): Promise<NotificationUpdateModel | undefined> {
        return this.getAllActiveNotificationUpdatesAsync(notificationIdentifier).then((activeUpdates) => {
            if (activeUpdates.length === 0) {
                return;
            }

            // sort by timestamp descending. The most recent update at first position.
            activeUpdates = _.sortBy(activeUpdates, (update) => update.date.valueOf() * -1);

            return activeUpdates.shift();
        });
    }

    private async getAllActiveNotificationUpdatesAsync(
        notificationIdentifier: NotificationIdentifierModel,
    ): Promise<NotificationUpdateModel[]> {
        return this.getNotificationUpdatesAsync().then((updates) => {
            // only get the updates for a specific notification and only the active ones.
            let filtered = updates.filter(
                (update) =>
                    NotificationIdentifierModel.compare(update.notificationId, notificationIdentifier) &&
                    update.isActive,
            );

            // sort by timestamp descending. The most recent update at first position.
            filtered = _.sortBy(filtered, (update) => update.date.valueOf() * -1);

            return filtered;
        });
    }

    public async getNotificationUpdatesAsync(): Promise<NotificationUpdateModel[]> {
        return this.localStorageCommonService
            .storageGetAsync<JsonNotificationUpdateModel[]>(KEY_NEWUPDATES)
            .then((updatesFromStorage) => {
                if (!updatesFromStorage) {
                    return [];
                }
                return updatesFromStorage.map((u) => new NotificationUpdateModelFromJson(u));
            });
    }

    public async saveNotificationUpdates(updates: NotificationUpdateModel[]): Promise<void> {
        return this.localStorageCommonService.storageSetAsync(KEY_NEWUPDATES, updates);
    }
}
